<template>
  <div>
    <InvoicingPC v-if="channelId === 'WEB'" ref="PC_child"></InvoicingPC>
    <InvoicingH5 v-if="channelId === 'MOBILE'" ref="H5_child"></InvoicingH5>
    <ConfirmBoxs :centerDialogVisible="confirmFlag" :confirmMsg="confirmMsg" icon="exclamation" @setConfirmFlag="setConfirmFlag"></ConfirmBoxs>
  </div>
</template>
<script>
import InvoicingPC from "../invoices/PC/invoicingPC.vue";
import InvoicingH5 from "../invoices/H5/invoicingH5.vue";
import ConfirmBoxs from "../../components/confirmBoxs.vue";
import { hideElement } from "@/utils/utils.js";
import { showDialog } from "vant";
import { 
  getInvoiceContactList,
  saveInvoiceContact,
  bookingDetail,
  saveInvoice,
  getInvoiceRecoed,
  repeatInvoiceEmail,
  searchInvoiceConfig
} from "@/api/bookingData";
import { 
  getInvoiceHeaderList,
  saveInvoiceHeader, 
} from "@/api/platformData";
export default {
  name: "invoicing",
  components: {
    InvoicingPC,
    InvoicingH5,
    ConfirmBoxs
  },
  provide() {
    return {
      InvoicingInfo: this,
    }
  },
  data() {
    return {
      orderInfo: {
        currencyCode: "CNY",
        totalPrice: "0",
        serviceFees: "0",
        userId:"",
        customerCode:"",
        orderServiceFeeAmount:0,
        costCenterid:"",
      },
      invoicingData: [],
      customInvoiceHeaderList:[],
      contactsData: [],
      choseinvoicing: {
        invoiceType:"1",
        isShowRepeatEmail:false,
      },
      choseContact:{},
      invoicingDetailData: {
        invoiceType:""
      },
      contactsDetailData: {},
      invoicingType:[
        { id: 1, value: this.$t("INVOICINGTYPE.NORMAL"),},
        { id: 2, value: this.$t("INVOICINGTYPE.APPRECIATE"),},
      ],
      choseInvoicingType:1,//发票类型
      choseServiceFeesInvoiicngType:1,
      confirmFlag: false,
      confirmMsg: "",
      invoicingTitle: "",
      showInvoiceTypeRadio:true,
      showForm:false,
      pageSize:10,
      pageIndex:1,
      totalCount:0,
    };
  },
  computed: {
    channelId(){
      return this.$objBaseInfo ? this.$objBaseInfo.channelId : "";
    },
    getAddInvoicingInfo(){
      switch(this.invoicingDetailData.invoiceType){
        case "1":
          return this.$t("INVOICINGHEADERTYPE.CORPORATION");
        case "2":
          return this.$t("INVOICINGHEADERTYPE.PERSONS");
        case "3":
          return this.$t("INVOICINGHEADERTYPE.NOCORPORATION");
      }
    },
  },
  watch: {},
  mounted() {
    //判断来源 CRM跳转过来隐藏部分元素
    if (this.$objBaseInfo) {
      hideElement(this);
    }
    this.showForm = this.parseBooleanQuery(this.$route.query.isResent);
    this.orderDetail();
    this.getInvoice();
  },
  methods: {
    parseBooleanQuery(value) {
      if (value === true || value === "true") {
        return true;
      }
      return false;
    },
    async getInvoiceHeader(val){
      let Params = {
        params:{
          customerCode:this.orderInfo.customerCode,//"YGO00032",//
          userId:this.orderInfo.userId,//订单预订人
          invoiceType:this.choseinvoicing.invoiceType,
          costCenterid:this.orderInfo.costCenterid,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        }
      };
      if(val){
        Params.params.id = val.id;
      }
      let that = this;
      await getInvoiceHeaderList(Params)
        .then(function (response) {
          if (response.code == "200") {
            if(val){
              if(response.data.invoiceHeaderList.length > 0){
                that.invoicingDetailData = response.data.invoiceHeaderList[0];
              }
            }else{
              that.invoicingData = response.data.invoiceHeaderList;
              that.customInvoiceHeaderList = response.data.customInvoiceHeaderList;
              that.totalCount = response.data.pagination.total;
              if(response.data.invoiceHeaderList.length > 0){
                that.choseinvoicing = response.data.invoiceHeaderList[0];
              }
            }
          }
        })
    },
    async saveInvoiceHeader(params){
      let that = this;
      params.params.bankAccountNumber = params?.params?.bankAccountNumber ? params.params.bankAccountNumber.replace(/\s+/g, '') : '';
      params.params.userId = this.orderInfo.userId;
      saveInvoiceHeader(params.params)
        .then(function (response) {
          if (response.code == "200") {
            that.getInvoiceHeader();
            switch (params.key) {
              case "Edit":
                that.confirmFlag = true;
                that.confirmMsg = that.$t("BANNERINFO.UPDATEADSSUCCESS");
                that.$refs.PC_child.showInvoicingList();
                break;
              case "Delete":
                that.confirmFlag = true;
                that.confirmMsg = "删除成功";
                break;
              case "Edit_H5":
                showDialog({
                  message: that.$t("BANNERINFO.UPDATEADSSUCCESS"),
                  theme: 'round-button',
                }).then(() => {
                  that.$refs.H5_child.showInvoicingList();
                }).catch(() => {});
                break;
              case "Delete_H5":
                showDialog({
                  message: '删除成功',
                  theme: 'round-button',
                }).then(() => {
                  that.$refs.H5_child.showInvoicingList();
                }).catch(() => {});
                break;
            } 
          }else{
            
          }
        })
    },
    async getInvoiceContactList(val){
      let Params = {
        params:{
          customerCode:this.orderInfo.customerCode,
          userId:this.orderInfo.userId,//订单预订人
          pageSize: 10,
          pageIndex: 1,
        }
      };
      if(val){
        Params.params.id = val.id;
      }
      let that = this;
      getInvoiceContactList(Params)
        .then(function (response) {
          if (response.code == "200") {
            if(val){
              if(response.data.invoiceContactList.length > 0){
                that.contactsDetailData = response.data.invoiceContactList[0];
              }
            }else{
              that.contactsData = response.data.invoiceContactList;
              if(response.data.invoiceContactList.length > 0){
                that.choseContact = response.data.invoiceContactList[0];
              }
            }
          }
          return response.data.invoiceContactList;
        })
    },
    async saveInvoiceContact(params){
      let that = this;
      saveInvoiceContact(params.params)
        .then(function (response) {
          if (response.code == "200") {
            that.getInvoiceContactList();
            switch (params.key) {
              case "Edit":
                that.confirmFlag = true;
                that.confirmMsg = that.$t("BANNERINFO.UPDATEADSSUCCESS");
                that.$refs.PC_child.showContactsList();
                break;
              case "Delete":
                that.confirmFlag = true;
                that.confirmMsg = "删除成功";
                break;
              case "Edit_H5":
                showDialog({
                  message: that.$t("BANNERINFO.UPDATEADSSUCCESS"),
                  theme: 'round-button',
                }).then(() => {
                  that.$refs.H5_child.showContactsList();
                }).catch(() => {});
                break;
              case "Delete_H5":
                showDialog({
                  message: '删除成功',
                  theme: 'round-button',
                }).then(() => {
                  that.$refs.H5_child.showContactsList();
                }).catch(() => {});
                break;
            } 
          }else{
            
          }
        })
    },
    setConfirmFlag() {
      this.confirmFlag = false;
    },
    async orderDetail() {
      const bookingId = this.$route.query.orderId;
      let orderParam = {
        params: {
          bookingId: bookingId,
          posCode: this.$objBaseInfo ? this.$objBaseInfo.poscode : "",
          returnDescriptiveInfo: true,
        },
      };
      // this.detailLoading = false;
      let that = this;
      await bookingDetail(orderParam)
        .then((res) => {
          that.detailLoading = false;
          if (res.code === 200) {
            if (res.data.error.code != 0) {
              that.confirmFlag = true;
              that.confirmMsg =
                that.$t("ERRORMESSAGE." + res.data.error.code) ===
                "ERRORMESSAGE." + res.data.error.code
                  ? that.$t("ERRORMESSAGE.NOTFOUND")
                  : that.$t("ERRORMESSAGE." + res.data.error.code);
              console.log(
                "创建订单失败, code:" , res.data.error.code,
                res.data.error.message
              );
            } else {
              var serviceFees = 0;
              if(res.data.serviceFees.amount){
                serviceFees += res.data.serviceFees.amount;
              }
              if(res.data.taxes.amount){
                serviceFees += res.data.taxes.amount;
              }
              if(res.data.emergencyServiceFee){
                serviceFees += Number(res.data.emergencyServiceFee);
              }
              that.orderInfo.currencyCode = res.data.currencyCode;
              that.orderInfo.totalPrice = (res.data.totalPrice).toFixed(2);
              that.orderInfo.serviceFees = serviceFees;
              that.orderInfo.orderServiceFeeAmount = serviceFees;
              that.orderInfo.userId = res.data.bookingAgent[0].userId;
              that.orderInfo.customerCode = res.data.customerCode;
              that.orderInfo.costCenterid = res.data.costCenterid;
              if(this.channelId === 'WEB' && that.$refs.PC_child){
                that.$refs.PC_child.roomFees = res.data.perPayDetails?.hotelFeeTotal;
                that.$refs.PC_child.maxRoomFees = res.data.perPayDetails?.hotelFeeTotal;
                that.$refs.PC_child.serviceFees = res.data.perPayDetails?.serviceFeeTotal.toFixed(2);
                that.$refs.PC_child.maxServiceFees = res.data.perPayDetails?.serviceFeeTotal.toFixed(2);
              }else if(this.channelId === 'MOBILE' && that.$refs.H5_child){
                that.$refs.H5_child.roomFees = res.data.perPayDetails?.hotelFeeTotal;
                that.$refs.H5_child.maxRoomFees = res.data.perPayDetails?.hotelFeeTotal;
                that.$refs.H5_child.serviceFees = res.data.perPayDetails?.serviceFeeTotal.toFixed(2);
                that.$refs.H5_child.maxServiceFees = res.data.perPayDetails?.serviceFeeTotal.toFixed(2);
              }
              if(!this.showForm){
                this.search();
                this.getInvoiceContactList();
              }
            }
          }
        })
    },
    async saveInvoiceRecoed(params){
      let that = this;
      params.params.orderServiceFeeAmount = that.orderInfo.orderServiceFeeAmount;
      params.params.bankAccountNumber = params?.params?.bankAccountNumber ? params.params.bankAccountNumber.replace(/\s+/g, '') : '';
      saveInvoice(params.params)
        .then(function (response) {
          if (response.code == "200") {
            //that.getInvoiceContactList();
            switch (params.key) {
              case "Save":
                that.confirmFlag = true;
                that.confirmMsg = that.$t("INVOICINGINFO.SUBMITBUTTONTIP");
                //that.$refs.PC_child.showContactsList();
                that.getInvoice();
                break;
              case "Save_H5":
                showDialog({
                  message: that.$t("INVOICINGINFO.SUBMITBUTTONTIP"),
                  theme: 'round-button',
                }).then(() => {
                  //that.$refs.H5_child.showContactsList();
                  that.getInvoice();
                }).catch(() => {});
                break;
            } 
          }else{
            
          }
        })
    },
    search(){
        let customerParam = {
        params: {
          customerCode: this.orderInfo.customerCode,
        },
      };
      searchInvoiceConfig(customerParam)
        .then((res) => {
            if(res.code == 200){
              if (res.data.list.length > 0) {
                this.choseInvoicingType = this.choseServiceFeesInvoiicngType = res.data.list[0].defaultInvoiceType;
                this.invoicingTitle = res.data.list[0].billingBody;
                if(this.choseInvoicingType == 2){
                  this.choseinvoicing.invoiceType = "3";
                    if(this.channelId === 'WEB'){
                    this.$refs.PC_child.choseInvoiceTitleTypeRules("3");
                  }
                }else{
                  this.showInvoiceTypeRadio = false;
                }
                this.getInvoiceHeader();
              }
            }
        })
    },
    async getInvoice(){
      const bookingId = this.$route.query.orderId;
      let param = {
        params: {
          bookingCode: bookingId,
        },
      };
      let that = this;
      await getInvoiceRecoed(param)
        .then((res) => {
          if (res.code === 200) {
            if(Object.keys(res.data).length !== 0){
              that.showForm = true;
              that.invoicingTitle = res.data.billingBody;
              that.choseInvoicingType = res.data.invoiceTypes;
              that.choseContact.personName = res.data.contactPerson;
              that.choseContact.personPhone = res.data.contactPhone;
              that.choseContact.personEmail = res.data.contectEmail;
              that.choseinvoicing.invoiceType = res.data.invoiceHeaderType.toString();
              that.choseinvoicing.headerName = res.data.headerName;
              that.choseinvoicing.taxCode = res.data.taxCode;
              that.choseinvoicing.bank = res.data.bank;
              that.choseinvoicing.bankAccountNumber = res.data.bankAccountNumber;
              that.choseinvoicing.registeredAddress = res.data.registeredAddress;
              that.choseinvoicing.registeredPhone = res.data.registeredPhone;
              if(this.channelId === 'MOBILE' && that.$refs.H5_child){
                that.$refs.H5_child.invoicingContacts = res.data.contactPerson;
                that.$refs.H5_child.contactPhone = res.data.contactPhone;
                that.$refs.H5_child.contactEmail = res.data.contectEmail;
                that.$refs.H5_child.choseContactsInfo = true;
                that.$refs.H5_child.showTaxRegisterNumber = res.data.invoiceHeaderType == 1?true:false;
                that.$refs.H5_child.taxCode = res.data.taxCode;
                that.$refs.H5_child.invoicingHeader = res.data.headerName;
                that.$refs.H5_child.isShowRepeatEmail = res.data.invoiceStatus == 1 ? true:false;
              }else if(this.channelId === 'WEB' && that.$refs.PC_child){
                that.$refs.PC_child.isShowRepeatEmail = res.data.invoiceStatus == 1 ? true:false;
              }
            }
          }
        })
    },
    repeatEmail(params){
      let that = this;
      repeatInvoiceEmail(params.params)
        .then(function (response) {
          if (response.code == "200") {
            switch (params.key) {
              case "PC":
                that.confirmFlag = true;
                that.confirmMsg = that.$t("HOTELORDEREMAIL.REPEATMSG");
                break;
              case "H5":
                showDialog({
                  message: that.$t("HOTELORDEREMAIL.REPEATMSG"),
                  theme: 'round-button',
                }).then(() => {}).catch(() => {});
                break;
            } 
          }else{
            
          }
        })
    }
  },
};
</script>